// extracted by mini-css-extract-plugin
module.exports = {"businessCell":"businessCell__FshF+","names":"names__ymA22"};